import FormField from "./FormField";

export default class FormFieldSelector extends FormField
{

}
